import { useSession } from '@components/app';

export const useClick2PayIsAllowed = () => {
    const { debitProfile } = useSession();

    return debitProfile?.allowedOperations.click2Pay ?? false;
};
